<section id="university-landing">
    <div class="content-wrapper">
        <div class="content-body">
            <div class="row">
                <div class="col-12">
                    <ngb-carousel [interval]="6000" [pauseOnHover]="false" *ngIf="landingSliders">
                        <ng-template ngbSlide>
                            <div class="carousel-img-wrapper">
                                <img [src]="landingSliders.one" class="img-fluid" alt="Random first slide"
                                     style="width: 100%; height: 85%"/>
                            </div>
                            <div class="carousel-caption"></div>
                        </ng-template>
                        <ng-template ngbSlide>
                            <div class="carousel-img-wrapper">
                                <img [src]="landingSliders.three" class="img-fluid" alt="Random second slide"
                                     style="width: 100%; height: 85%"/>
                            </div>
                            <div class="carousel-caption"></div>
                        </ng-template>
                        <ng-template ngbSlide>
                            <div class="carousel-img-wrapper">
                                <img [src]="landingSliders.two" class="img-fluid" alt="Random third slide"
                                     style="width: 100%; height: 85%"/>
                            </div>
                            <div class="carousel-caption"></div>
                        </ng-template>
                        <ng-template ngbSlide>
                            <div class="carousel-img-wrapper">
                                <img [src]="landingSliders.four" class="img-fluid" alt="Random third slide"
                                     style="width: 100%; height: 85%"/>
                            </div>
                            <div class="carousel-caption"></div>
                        </ng-template>
                        <ng-template ngbSlide>
                            <div class="carousel-img-wrapper">
                                <img [src]="landingSliders.five" class="img-fluid" alt="Random third slide"
                                     style="width: 100%; height: 85%"/>
                            </div>
                            <div class="carousel-caption"></div>
                        </ng-template>
                        <ng-template ngbSlide>
                            <div class="carousel-img-wrapper">
                                <img [src]="landingSliders.six" class="img-fluid" alt="Random third slide"
                                     style="width: 100%; height: 85%"/>
                            </div>
                            <div class="carousel-caption"></div>
                        </ng-template>
                    </ngb-carousel>
                </div>
            </div>
            <div class="row mt-2 mb--45px">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header shadow-bottom-light">
                            <h2 class="card-title">Admission Open - Apply Now</h2>
                        </div>
                        <div class="card-body mt-1">
                            <form class="form" novalidate [formGroup]="addStudentForm">
                                <div class="row">
                                    <div class="col-sm-3 col-12">
                                        <div class="form-group mb-2">
                                            <input type="text" class="form-control" placeholder="Name"
                                                   formControlName="name"/>
                                        </div>
                                    </div>
                                    <div class="col-sm-3 col-12">
                                        <div class="form-group mb-2">
                                            <input type="email" class="form-control" placeholder="Email"
                                                   formControlName="email"/>
                                        </div>
                                    </div>
                                    <div class="col-sm-3 col-12">
                                        <div class="form-group mb-2">
                                            <input type="number" class="form-control" placeholder="Contact"
                                                   formControlName="contact"/>
                                        </div>
                                    </div>
                                    <div class="col-sm-3 col-12">
                                        <div class="form-group mb-2">
                                            <select class="form-control" formControlName="course_id">
                                                <option value="">Choose Course</option>
                                                <option [value]="course?.id"
                                                        *ngFor="let course of courses">{{course?.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12 text-center shadow-upper-light">
                                        <button type="submit" class="btn btn-primary mt-1" rippleEffect
                                                (click)="submit()">Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3" *ngIf="user && user['userId']">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header shadow-bottom-light">
                            <h2 class="card-title">Complete Admission Form</h2>
                        </div>
                        <div class="card-body text-center">
                            <button class="btn btn-primary mt-2" (click)="navigateTo('admission')"><i
                                    class="fab fa-wpforms mr-1"></i>Complete Admission Form
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header shadow-bottom-light">
                            <h2 class="card-title">About Us</h2>
                        </div>
                        <div class="card-body pb-1">
                            <div class="row mt-2">
                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                    <img [src]="aboutUsImage" width="100%"/>
                                </div>
                                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-12">
                                    <p class="card-text" [innerHTML]="aboutUsText"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header shadow-bottom-light">
                            <h2 class="card-title">Courses</h2>
                        </div>
                        <div class="card-body">
                            <div class="row kb-search-content-info match-height mt-2">
                                <div class="kb-search-content col-sm-6 col-md-4"
                                     *ngIf="updateCourseData && course1Data.file_id !== ''">
                                    <div class="card text-center cursor-pointer">
                                        <img [src]="course1Data.image" [alt]="course1Data.name"/>
                                        <div class="card-body">
                                            <h4 [innerHTML]="course1Data.name"></h4>
                                            <p class="card-text mt-1" [innerHTML]="course1Data.info"></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="kb-search-content col-sm-6 col-md-4"
                                     *ngIf="updateCourseData && course2Data.file_id !== ''">
                                    <div class="card text-center cursor-pointer">
                                        <img [src]="course2Data.image" [alt]="course2Data.name"/>
                                        <div class="card-body">
                                            <h4 [innerHTML]="course2Data.name"></h4>
                                            <p class="card-text mt-1" [innerHTML]="course2Data.info"></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="kb-search-content col-sm-6 col-md-4"
                                     *ngIf="updateCourseData && course3Data.file_id !== ''">
                                    <div class="card text-center cursor-pointer">
                                        <img [src]="course3Data.image" [alt]="course3Data.name"/>
                                        <div class="card-body">
                                            <h4 [innerHTML]="course3Data.name"></h4>
                                            <p class="card-text mt-1" [innerHTML]="course3Data.info"></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="kb-search-content col-sm-6 col-md-4"
                                     *ngIf="updateCourseData && course4Data.file_id !== ''">
                                    <div class="card text-center cursor-pointer">
                                        <img [src]="course4Data.image" [alt]="course4Data.name"/>
                                        <div class="card-body">
                                            <h4 [innerHTML]="course4Data.name"></h4>
                                            <p class="card-text mt-1" [innerHTML]="course4Data.info"></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="kb-search-content col-sm-6 col-md-4"
                                     *ngIf="updateCourseData && course5Data.file_id !== ''">
                                    <div class="card text-center cursor-pointer">
                                        <img [src]="course5Data.image" [alt]="course5Data.name"/>
                                        <div class="card-body">
                                            <h4 [innerHTML]="course5Data.name"></h4>
                                            <p class="card-text mt-1" [innerHTML]="course5Data.info"></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="kb-search-content col-sm-6 col-md-4"
                                     *ngIf="updateCourseData && course6Data.file_id !== ''">
                                    <div class="card text-center cursor-pointer">
                                        <img [src]="course6Data.image" [alt]="course6Data.name"/>
                                        <div class="card-body">
                                            <h4 [innerHTML]="course6Data.name"></h4>
                                            <p class="card-text mt-1" [innerHTML]="course6Data.info"></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center col-12" style="display: none;">
                                    <h4 class="mt-4"> Search result not found!! </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header shadow-bottom-light">
                            <h2 class="card-title">Why Us ?</h2>
                        </div>
                        <div class="card-body mt-1">
                            <ul ngbNav #navFilled="ngbNav" class="nav-tabs nav-fill">
                                <li ngbNavItem>
                                    <a ngbNavLink>{{whyUs1Data?.name}}</a>
                                    <ng-template ngbNavContent>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                                    <img [src]="whyUs1Data.image" width="100%"/>
                                                </div>
                                                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-12">
                                                    <p [innerHTML]="whyUs1Data.info"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </li>
                                <li ngbNavItem>
                                    <a ngbNavLink>{{whyUs2Data?.name}}</a>
                                    <ng-template ngbNavContent>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                                    <img [src]="whyUs2Data.image" width="100%"/>
                                                </div>
                                                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-12">
                                                    <p [innerHTML]="whyUs2Data.info"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </li>
                                <li ngbNavItem>
                                    <a ngbNavLink>{{whyUs3Data?.name}}</a>
                                    <ng-template ngbNavContent>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                                    <img [src]="whyUs3Data.image" width="100%"/>
                                                </div>
                                                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-12">
                                                    <p [innerHTML]="whyUs3Data.info"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </li>
                                <li ngbNavItem>
                                    <a ngbNavLink>{{whyUs4Data?.name}}</a>
                                    <ng-template ngbNavContent>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                                    <img [src]="whyUs4Data.image" width="100%"/>
                                                </div>
                                                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-12">
                                                    <p [innerHTML]="whyUs4Data.info"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </li>
                            </ul>
                            <div [ngbNavOutlet]="navFilled" class="mt-2"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="row" *ngIf="!user || !user.userId">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="card-header shadow-bottom-light">
                            <h2 class="card-title">Admission Open - Apply Now</h2>
                        </div>
                        <div class="card-body mt-1">
                            &lt;!&ndash;<button class="btn btn-primary">Complete Admission Form</button>&ndash;&gt;
                            <form class="form" novalidate [formGroup]="addStudentForm">
                                <div class="row">
                                    <div class="col-sm-6 col-12">
                                        <div class="form-group mb-2">
                                            <input type="text" class="form-control" placeholder="Name"
                                                   formControlName="name"/>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-12">
                                        <div class="form-group mb-2">
                                            <input type="email" class="form-control" placeholder="Email"
                                                   formControlName="email"/>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-12">
                                        <div class="form-group mb-2">
                                            <input type="number" class="form-control" placeholder="Contact"
                                                   formControlName="contact"/>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-12">
                                        <div class="form-group mb-2">
                                            <select class="form-control" formControlName="course_id">
                                                <option value="">Choose Course</option>
                                                <option [value]="course?.id"
                                                        *ngFor="let course of courses">{{course?.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <button type="submit" class="btn btn-primary pull-right" rippleEffect
                                                (click)="submit()">Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>-->
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header shadow-bottom-light">
                            <h2 class="card-title">Contact Us</h2>
                        </div>
                        <div class="card-body mt-2">
                            <div class="row">
                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                    <p class="font-weight-bold mb-0">Address -</p>
                                    <p [innerHTML]="contactUsData?.address"></p>
                                    <p class="mt--10px" [innerHTML]="contactUsData?.district"></p>
                                    <p class="mt--10px" [innerHTML]="contactUsData?.state?.name"></p>
                                    <p class="mt--10px" [innerHTML]="contactUsData?.pin_code"></p>
                                    <p class="font-weight-bold mb-0">Contact -</p>
                                    <p [innerHTML]="contactUsData?.contact"></p>
                                </div>
                                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-12">
                                    <iframe *ngIf="contactUsData.location" [src]="contactUsData.location | safePipe"
                                            width="100%" height="450"
                                            style="border:0;" allowfullscreen="" loading="lazy"></iframe>
                                    <iframe *ngIf="!contactUsData.location" [src]="mapUrl | safePipe" width="100%"
                                            height="450"
                                            style="border:0;" allowfullscreen="" loading="lazy"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
